import request from '@/utils/request';

// 获取搜索列表
export function getSearchItem() {
  return request({
    url: `/v1/portal/web/whitelist/search/item`,
    method: 'get'
  });
}
// 获取搜索应用
export function getAppList(data) {
  return request({
    url: `/v1/portal/web/whitelist/search`,
    method: 'get',
    params: data
  });
}
